import apiService from '@/utils/api-client'
import appConfig from '@/utils/appConfig'

export default {
  async getRates({ commit }, payload) {
    try {
      const response = await apiService.post('/rates/get', payload)
      commit('SET_ACTIVE_RATES', response.data)
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getRatesCommon({ commit }, payload) {
    try {
      const response = await apiService.post('/rates/get', payload, { baseURL: appConfig.VUE_APP_API_USERS_URL })
      commit('SET_ACTIVE_RATES', response.data)
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
